import { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;

  & strong {
    color: #e74c3c;
  }

  .modal-section {
    position: fixed;
    top: 10vh;
    left: 25vw;
    width: 50vw;
    max-height: 80vh;
    background-color: white;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 991px) {
      top: 10vh;
      left: 15vw;
      width: 70vw;
      max-height: 80vh;
    }
    @media screen and (max-width: 767px) {
      left: 10vw;
      width: 80vw;
    }
  }

  .header {
    display: flex;
    padding: 10px 10px;
    & img {
      margin-left: auto;
      width: 35px;
      cursor: pointer;
    }
  }
  .title {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    & h4 {
      color: #3bb77e;
    }
  }

  .modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    padding: 0px 36px 36px 36px !important;
    & > span {
      color: black;
    }
  }

  .inputWrapper {
    width: 100%;
    margin-bottom: 20px;
    & h6 {
      margin-bottom: 10px;
      ::after {
        content: "*";
        margin-left: 2px;
      }
    }
    & input {
      height: 38px;
      margin-bottom: 10px;
      ::placeholder {
        font-size: 14px;
        color: #6c757da5;
      }
      :focus {
        border-color: #3bb77e !important;
        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
      }
    }
    .col {
      display: flex;
      flex-direction: column;
      width: 50%;
      & input {
        width: 100%;
        padding-right: 0;
      }
    }
    @media screen and (max-width: 575px) {
      .row {
        display: flex;
        flex-direction: column;
        .col {
          width: 100%;
        }
      }
    }
  }

  & textarea {
    min-height: 150px;
    ::placeholder {
      font-size: 14px;
      color: #6c757da5;
    }
    :focus {
      border-color: #3bb77e !important;
      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
    }
  }
  .btnWrapper {
    width: 100%;
    & button {
      width: 100%;
    }
  }

  .checkboxWrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
    margin-bottom: 20px;
    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .designCheck {
    margin-bottom: 30px;
    display: flex;
    flex-wrap: wrap;
  }
`;

const CheckBox = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${(props) => (props.design ? "5px" : "0")};
  word-break: keep-all;
`;

const CheckBoxLabel = styled.label`
  width: ${(props) => (props.design ? "fit-content" : "100%")};
  font-size: 1rem;
  padding: ${(props) => (props.design ? "10px 20px" : "10px 10px")};
  overflow: hidden;
  border: 2px solid #ececec;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.checked ? "#d6f2e5" : "#fff")};
  color: #4e4e4e;
  border-color: ${(props) => (props.checked ? "#3bb77e" : "#ececec")};
  border-radius: 10px;
  position: relative;
  cursor: pointer;

  & img {
    margin: 0 auto;
  }

  .label_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4e4e4e;
    font-size: 14px;
    text-align: center;

    & i {
      padding-top: 1px;
      :hover {
        color: #3bb77e;
      }
    }
  }
`;

const FileWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  row-gap: 10px;
  & input {
    padding: 6px 5px;
  }
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const PrintInquiryModal = ({
  onClickInquiry,
  submitInquiry,
  onChangeInquiry,
  inquiryInputs,
}) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return onClickInquiry();
  };

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="header">
            <img
              src="/assets/imgs/page/common/modal_close_icon.png"
              alt="modal_close_icon"
              onClick={onClickInquiry}
            />
          </div>
          <div className="title">
            <h4>정보를 입력해주세요</h4>
          </div>
          <div className="modal-content">
            <div className="inputWrapper">
              <div className="row">
                <div className="col">
                  <h6>문의자(업체) 명</h6>
                  <input
                    type="text"
                    onChange={(e) => onChangeInquiry(e, "name")}
                  />
                </div>
                <div className="col">
                  <h6>문의자 연락처</h6>
                  <input
                    type="text"
                    onChange={(e) => onChangeInquiry(e, "tel")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>이메일</h6>
                  <input
                    type="text"
                    onChange={(e) => onChangeInquiry(e, "email")}
                  />
                </div>
                <div className="col">
                  <h6>수량</h6>
                  <input
                    type="text"
                    onChange={(e) => onChangeInquiry(e, "cnt")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>인쇄를 원하는 상품</h6>
                  <input
                    type="text"
                    onChange={(e) => onChangeInquiry(e, "usages")}
                    placeholder="ex) EL606 택배봉투 (소)"
                  />
                </div>
              </div>
              <div className="row mb-20">
                <div className="col">
                  <h6>문의 내용</h6>
                  <textarea
                    type="text"
                    onChange={(e) => onChangeInquiry(e, "content")}
                    placeholder="ex) 언제까지 필요하신가요, 어떤 디자인서비스가 필요하신가요, 추가적인 문의사항을 남겨주세요"
                  />
                </div>
              </div>
              <div className="row mb-20">
                <div className="col">
                  <span className="h6 text-dark">첨부 파일</span>
                  <FileWrapper>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => onChangeInquiry(e, "file1")}
                    />
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => onChangeInquiry(e, "file2")}
                    />
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => onChangeInquiry(e, "file3")}
                    />
                  </FileWrapper>
                </div>
              </div>
              <div className="row mb-20">
                <div className="col">
                  <span className="h6 text-dark">유의 사항</span>
                  <ul className="border rounded p-3">
                    <li>
                      1. 모니터의 색상과 최종 인쇄물의 색상은 차이가 있을 수
                      있습니다.
                    </li>
                    <li>
                      2. 고속 인쇄와 재단 과정을 거치므로 인쇄 위치 및 사이즈의
                      오차가 발생 할 수 있습니다.
                    </li>
                    <li>
                      3. 열풍에 의한 건조 방식으로 잉크가 증발하여 기포가
                      생기거나 색상이 빠지는 경우가 발생할 수 있습니다.
                    </li>
                    <li>
                      4. 인쇄 면적이 넓을 시 비용이 추가 될 수 있습니다. 또한
                      색상 표현이 고르지 않거나 물결 무늬가 생길 수 있습니다.
                    </li>
                    <li>5. 위 사유로 인한 재작업이나 반품은 불가합니다.</li>
                    <li>
                      6. 인쇄 관련된 문의는 칼렛스토어 채널톡으로 언제든지
                      남겨주세요.
                    </li>
                  </ul>
                  <div className="d-flex flex-row justify-content-start align-items-center">
                    <div className="custome-checkbox">
                      <input
                        type="checkbox"
                        id="checkBox1"
                        className="form-check-input"
                        onChange={(e) => onChangeInquiry(e, "policy")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkBox1"
                        style={{
                          textTransform: "capitalize",
                          color: "#696969",
                          fontSize: "16px",
                        }}
                      >
                        <span>유의사항에 동의합니다.</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="btnWrapper">
              <button className="btn" onClick={submitInquiry}>
                문의하기
              </button>
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export default PrintInquiryModal;
